import { Button, Flex } from '@mantine/core'
import { ReactNode } from 'react'
interface ButtonConfig {
  type: 'button' | 'submit' | 'reset' | undefined
  label: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  icon?: ReactNode
  loading?: boolean
  color?: string
  disabled?: boolean
}
interface Props {
  customJustify?:
    | 'space-between'
    | 'center'
    | 'end'
    | 'flex-start'
    | 'space-around'
    | 'space-evenly'
    | 'start'
  customButtons?: ButtonConfig[]
}
const CustomButtom: React.FC<Props> = ({ customButtons, customJustify }) => {
  return (
    <>
      <Flex
        mt={20}
        bottom={0}
        pos={'relative'}
        justify={customJustify ?? 'space-between'}
      >
        {customButtons?.map((button, index) => (
          <Button
            type={button.type}
            onClick={button.onClick}
            loading={button.loading}
            color={button.color}
            disabled={button.disabled}
            leftIcon={button.icon}
            key={index}
          >
            {button.label}
          </Button>
        ))}
      </Flex>
    </>
  )
}

export default CustomButtom
